'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _Icon = require('../Icon');

var _Icon2 = _interopRequireDefault(_Icon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*eslint-disable */
var MemberLogged = function MemberLogged(props) {
  return _react2.default.createElement(
    _Icon2.default,
    _extends({ viewBox: '0 0 17 21' }, props),
    _react2.default.createElement(
      'g',
      null,
      _react2.default.createElement(
        'title',
        null,
        'Group 5'
      ),
      _react2.default.createElement(
        'g',
        { fill: 'currentColor', fillRule: 'evenodd' },
        _react2.default.createElement('path', { d: 'M16.65 16.935c-.517.908-1.736 1.346-2.695 1.253l-1.178 2.14c-.298.522-.828.862-1.337.557-.51-.305-.551-.896-.253-1.418l1.317-2.21c-.55-.81-.78-2.052-.262-2.961.71-1.246 2.275-1.667 3.493-.938 1.217.729 1.627 2.33.916 3.577zm-.972-1.372c0-.728-.577-1.318-1.288-1.318-.71 0-1.288.59-1.288 1.318 0 .728.578 1.318 1.288 1.318.711 0 1.287-.59 1.287-1.318z'
        }),
        _react2.default.createElement('path', { d: 'M3.866 5.148c0-2.093 1.725-3.796 3.845-3.796s3.844 1.703 3.844 3.796-1.724 3.795-3.844 3.795-3.845-1.702-3.845-3.795zM.89 16.76l.009-.203c.163-3.478 1.602-6.449 3.785-7.959a4.638 4.638 0 0 0 3.027 1.136 4.642 4.642 0 0 0 3.027-1.136c1.065.737 1.95 1.826 2.599 3.148.29-.06.591-.093.9-.094-.704-1.526-1.689-2.81-2.889-3.686a4.503 4.503 0 0 0 1.008-2.818c0-2.529-2.084-4.587-4.645-4.587-2.562 0-4.646 2.058-4.646 4.587 0 1.067.387 2.038 1.009 2.818C1.591 9.777 0 13.318 0 17.197a.44.44 0 0 0 .442.437h9.717a4.274 4.274 0 0 1-.248-.874H.89z'
        })
      )
    )
  );
};
/*eslint-enable */

exports.default = MemberLogged;
//# sourceMappingURL=MemberLogged.js.map



// WEBPACK FOOTER //
// ./~/wix-style-react/dist/src/Icons/dist/components/MemberLogged.js